(function (angular) {
    'use strict';
    angular.module('app.directory', []);
})(angular);

